import React from 'react';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import EnrollmentCell from './enrollment-cell';

const BeneficiariesUpdate = ({submitting}) => {
    return ( 
    <EnrollmentCell title="Beneficiary Update" buttonName="Update Beneficiaries" submitting={submitting} enrollmentType={EnrollmentType.BenficiaryChange} lastColumn={true}>
        <p className="text-sm">
          You may update your Life Insurance beneficiary at any time which will replace any previous designations on file.   
        </p>
        <p className="text-sm mt-4">
        This option is for those who <span className='underline'>only</span> want to update their beneficiary for life insurance.
        </p>
        <p className="text-sm mt-4">
        If additional changes are needed, please review Open Enrollment or Qualifying Life Event Update procedures.  
        </p>
    </EnrollmentCell>
);
}
 
export default BeneficiariesUpdate;